export const Config = {
  genderList: [
    {name: 'Male', value: 'male'},
    {name: 'Female', value: 'female'}
  ],
  questionTypes: {
    0: 'Single Punch',
    1: 'Multipunch',
    2: 'Open End-Text',
    3: 'Numeric Open Ended'
  },

  selectedLng:'ENGLISH',
  selectedCnt:'US',
  numberOfSurvey : 3,
  masterZipQues : ['STATE', 'REGION', 'DMA_CODE', 'DMA_NAME'],
  ageRange: { min: 13, max: 99 }
};
